import { render, staticRenderFns } from "./taskManager.vue?vue&type=template&id=868b33b2&scoped=true&"
import script from "./taskManager.vue?vue&type=script&lang=js&"
export * from "./taskManager.vue?vue&type=script&lang=js&"
import style0 from "./taskManager.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./taskManager.vue?vue&type=style&index=1&id=868b33b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868b33b2",
  null
  
)

export default component.exports